<!--  -->
<template>
  <div class="header">
    <div class="isCollapsediv" @click="updateCollapse">
      <i class="el-icon-s-unfold" v-if="isCollapse"></i>
      <i class="el-icon-s-fold" v-else></i>
    </div>
    <div class="headerTitle">OSCE管理系统</div>
    <div class="headerRight">
      <span @click="logout" style="color: white;cursor: pointer">退出登录</span>
<!--      <img-->
<!--        src="https://lin-xin.gitee.io/example/work/static/img/img.146655c9.jpg"-->
<!--        alt-->
<!--        class="user-avator"-->
<!--      />-->
<!--      <el-dropdown @command="selectOption">-->
<!--        <span class="el-dropdown-link">-->
<!--          李木子-->
<!--          <i class="el-icon-caret-bottom"></i>-->
<!--        </span>-->
<!--        <el-dropdown-menu slot="dropdown">-->
<!--          <el-dropdown-item :command="1">个人信息</el-dropdown-item>-->
<!--          <el-dropdown-item :command="2">退出登录</el-dropdown-item>-->
<!--        </el-dropdown-menu>-->
<!--      </el-dropdown>-->
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapMutations } from "vuex";
import VueCookies from 'vue-cookies'

export default {
  //import引入的组件需要注入到对象中才能使用
    components: {},
  data() {
    //这里存放数据
    return {};
  },
  computed: {
    ...mapState(["isCollapse"])
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //方法集合
  methods: {
    ...mapMutations([
      "updateKeepPageTabs",
      "updateBreadcrumb",
      "updateleftMenuActiveName",
      "updateCollapse"
    ]),
      logout(){
          VueCookies.remove('token');
          this.$router.push({name:'login'})
      },
    selectOption(val) {
      console.log(val);
      if (val == 1) {
      } else {
        //  this.$removeSessionStore('vuex');
        this.updateKeepPageTabs({
          type: "all",
          data: { routeName: this.$route.name }
        });
        this.updateBreadcrumb([]);
        this.updateleftMenuActiveName("");
        this.$router.push({
          name: "login"
        });
      }
    }
  }
};
</script>
<style lang='less'>
//@import url(); 引入公共css类

</style>



// WEBPACK FOOTER //
// src/components/topHeader.vue